import { supabase } from '../supabaseClient';

async function getFosDetails(cpId) {
    let query = supabase.from('FOS').select('*', { count: 'exact' }).eq('cpId',cpId)
    const { data, error, count } = await query;
    if (data) return { data, count };
    else throw error;
}

async function getUnitIdFromInventory(projectId){
    let query = supabase.from('Inventory').select('*', { count: 'exact' }).eq('projectId',projectId)
    const { data, error, count } = await query;
    if (data) return { data, count };
    else throw error;
}
async function updateLeadStatus(leadId,status) {
    const { data, error } = await supabase
        .from('LeadStatus')
        .update({ status: status ,last_updated_at:Date.now()})
        .eq('leadId', leadId)
    if (data) return data;
    else throw error;
}
// CheckSiteVisit has done
async function checkSiteVisitHasDone(leadId){
    let query = supabase.from('SiteVisits').select('*', { count: 'exact' })
    .eq('leadId',leadId)
    const { data, error, count } = await query;
    if (data) return { data, count };
    else throw error;
}

async function getSiteVisitForConflicts(siteVisitId) {
    let query = supabase.from('SiteVisits').select('*,leadId(personId(name, email, contactNumber), leadDisplayId),userId(name),cpId(billingName), fosId(name), projectId(projectId , projectName)').eq('siteVistId',siteVisitId)

    const { data, error } = await query;
    if (data) return {data};
    else throw error
    
}
export { getFosDetails,getUnitIdFromInventory ,updateLeadStatus,checkSiteVisitHasDone, getSiteVisitForConflicts}